module.exports = "dist/images/[1]-[2]-[3].1608f7c.jpg";